import { isInitialized, getConfig } from '../core/config';
import { buildEndpoint } from '../core/endpoint';
import { getStorefrontConnectionId } from '../core/telemetry';
import { resolveUtmParameters } from '../core/attribution';

export async function trackPageView(cartValue?: number, itemCount?: number): Promise<void> {
  if (!isInitialized()) return;
  if (typeof document === 'undefined') return;

  const config = getConfig();
  const connectionId = getStorefrontConnectionId(config.storeSlug);

  try {
    const endpoint = buildEndpoint('/v1/storefront/shops/:storeSlug/ping', {
      storeSlug: config.storeSlug,
    });
    await fetch(`${config.apiBaseUrl}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        referer: document.referrer || undefined,
        cart_value: cartValue ?? undefined,
        item_count: itemCount ?? undefined,
        connection_id: connectionId ?? undefined,
        utm: resolveUtmParameters(config.storeSlug),
      }),
    });
  } catch {
    // Intentionally silent - analytics should never block the user experience
  }
}
